
export class concretepourrecord {
  air_Temp: number;
  amount_Poured: number;
  archived: boolean;
  batchTime: Date;
  compaction: string;
  compactionId: number;
  concretePourInspectionId: string;
  concrete_Temp: number;
  cube_Set_Ref: string;
  concreteStrength: string;
  delivery_Number: string;
  endTime: Date;
  flow: number;
  id: string;
  inspection: string;
  onSite: Date;
  plant_Num: string;
  position: number;
  pour_Date: Date;
  startTime: Date;
  sump: number;
  total_Amount_Poured: number;
  void: number;
  weather;
  weatherId: number;
}
